import { useMemo } from 'react';
import Particles, { ParticlesProvider, type ParticlesPluginRegistrar } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import { useTheme } from '../theme/useTheme';
import { resolveParticleOptions, type ParticlePalette } from './particleOptions';

// Must be a stable reference for the whole app lifecycle (tsParticles enforces this).
const initParticlesEngine: ParticlesPluginRegistrar = async (engine) => {
  await loadSlim(engine);
};

export function ParticlesBackground({ palette = 'accent' }: { palette?: ParticlePalette }) {
  const { isDark } = useTheme();

  // `resolveParticleOptions` caches per (enabled, theme, palette) so `<Particles>`
  // gets a stable `options` reference and only reloads when the config truly changes.
  const options = useMemo(() => resolveParticleOptions(isDark, palette), [isDark, palette]);

  return (
    <ParticlesProvider init={initParticlesEngine}>
      <Particles id="tsparticles" options={options} />
    </ParticlesProvider>
  );
}
